import VueI18n from 'vue-i18n'
import Vue from 'vue'
import zh from './locales/zh-CN.js'
import en from './locales/en-US.js'
import ft from './locales/ft.js'
Vue.use(VueI18n);

const i18n = new VueI18n({
	locale: localStorage.getItem('language') || 'zh', // 语言标识
	fallbackLocale: 'zh', //没有英文的时候默认中文语言
	silentFallbackWarn: true, //抑制警告
	messages: {
		zh: {
			...zh
		},
		en: {
			...en
		},
		ft: {
			...ft
		},
	}
})
export default i18n;